<template>
  <div>
    <div class="notification is-success">
      {{$t('payment.payment-processing')}}
    </div>
  </div>
</template>


<script>
export default {
  name: 'AuthorizingPayment',
  components: {},
  async mounted() {
    if (this.$route.query && this.$route.query.amazonCheckoutSessionId) {
      let res = await this.$store.dispatch('$_checkout/completeAmazonPay', {
        session: this.$route.query.amazonCheckoutSessionId,
      })
      if (res.paid) {
        const redirect = {
          id: res.order.id,
          key: res.order.token,
        }
        this.$router.push({name: 'order-complete', params: redirect})
        this.$store.dispatch('clearCart')
        this.$store.dispatch('$_checkout/clearPaymentSession')
      } else {
        //fehler redirect back
        this.$store.dispatch('$_checkout/clearPaymentSession')
        this.$router.push({name: 'checkout', query: {pcb: res.code}})
      }
    } else {
      this.$router.push({name: 'checkout'})
    }
  },
}
</script>

<style scoped lang="sass"></style>
